module.exports = __webpack_public_path__ + "static/media/stop-6.5874805f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-6.svg
// module id = 1373
// module chunks = 0